import { StopLocation, StopState } from '../state/stopState';
import { ImporterEvent } from './importer-event';
import { ImporterEventType } from './importer-event-type';

export class EnableContinueButtonEvent implements ImporterEvent {
  type = ImporterEventType.EnableContinueButton;

  constructor(public enable: boolean, public data: StopState[]) {}
}
